<template>
  <div class="activity-container">
    <div class="content-title">下载中心</div>
    <div class="content-item">
      <OrganizationTree @nodeClick="nodeClick"></OrganizationTree>
      <div class="content-right">
        <div class="right-title">任务列表</div>
        <div class="query">
          <MyForm class="search-form" :formOptions="queryForm" :inline="true"></MyForm>
        </div>
        <MyTable :table-options="tableOptions" border max-height="60vh">
          <template #state="{ row }">
            {{ stateMap[row.state] }}
          </template>
          <template #handler="{ row }">
            <MyButton link icon="Download" @click="click_download(row)">下载</MyButton>
          </template>
        </MyTable>
      </div>
    </div>
    <MyPagination :params="paginationParams" :total="total" @get-list="getTaskList" ref="paginationRef" />
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import OrganizationTree from "@/components/Common/OrganizationTree.vue";
import { dayjs, ElMessage } from "element-plus";
import organizationApi from "@/api/organization";

const currentUnit = ref({});
const nodeClick = (data) => {
  currentUnit.value = data;
  paginationParams.OrganizationId = data.id;
}

const stateMap = {
  '-1': "失败",
  '0': "未开始",
  '1': "进行中",
  '2': "已完成",
}
const queryForm = reactive({
  itemList: [
    {
      type: "Date",
      label: "日期筛选:",
      prop: "daterange",
      attrs: {
        type: "daterange",
        startPlaceholder: "开始时间",
        rangeSeparator: "至",
        endPlaceholder: "结束时间",
        placeholder: "请输入关键词",
        valueFormat: "YYYY-MM-DD",
      },
      events: {
        change: (formData,formRef, val) => {
          if(!val){
            formData.StartDate = undefined;
            formData.EndDate = undefined;
            return;
          }
          formData.StartDate = val[0];
          formData.EndDate = val[1];
        },
      },
    },
    [
      {
        type: "Button",
        value: "查询",
        attrs: {
          icon: "Search",
        },
        events: {
          click(formData) {
            paginationParams.StartDate = formData.StartDate;
            paginationParams.EndDate = formData.EndDate;
          },
        },
      },
    ]
  ],
});

const tableOptions = reactive({
  colList: [
    { label: "序号", type: "index", width: 60 },
    { label: "任务名称", prop: "name" },
    { label: "创建日期", prop: "creationTime" },
    { label: "状态", type: "slot", slot_name: "state" },
    { label: "操作", type: "slot", slot_name: "handler", minWidth: 150 },
  ],
  tableData: [],
});

// 分页
const paginationParams = reactive({
  OrganizationId: "",
  StartDate: "",
  EndDate: "",
})
const paginationRef = ref(null);
const total = ref(0);
const getTaskList = (params = paginationRef.value.getList_params) => {
  if(!params.OrganizationId){
    return;
  }
  organizationApi.getTaskList(params).then((res) => {
    total.value = res.data.totalCount;
    tableOptions.tableData = res.data.items.map(item=>{
      item.creationTime = dayjs(item.creationTime).format("YYYY-MM-DD HH:mm:ss");
      return item;
    });
  })
}

const click_download = (row) => {
  if(!row.fileUrl){
    return ElMessage.warning("任务正在进行中，请稍后查看");
  }
  window.open(row.fileUrl);
}
</script>

<style lang="scss" scoped>
.content-item{
  display: flex;
  min-height: 60vh;
  .content-right {
    flex: 1;
    overflow: hidden;
    .right-title {
      background: #134e92;
      height: 40px;
      line-height: 40px ;
      color: #66baec;
      display: flex;
      justify-content: space-between;
      padding-left: 20px;
    }
    .query {
      background: #03386a;
      padding: 0 20px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #66baec;
      .search-form {
        padding-top: 20px;
      }
    }
  }
}
.myform{
  padding: 20px 40px;
  :deep(){
    .el-input,.el-date-editor{
      width: 360px;
    }
  }
}
</style>